import * as React from "react";
import "./Icon.css";
const SvgArrowIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon arrow ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(0,12)">
      <path
        d="M24 22.34 2.5 2.5h43z"
        style={{
          fill: "currentColor",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 5,
        }}
      />
    </g>
  </svg>
);
export default SvgArrowIcon;
